import { useIntl } from 'react-intl';

const ListOrganization = () => {
  const intl = useIntl();
  return (
    <div className="row ml-1 mb-4">
      <div className="col-12">
        <div>
          {intl.formatMessage(
            {
              defaultMessage:
                // 'Le tre principali <strong>strutture di supporto</strong>, trasversali alle diverse aree aziendali, sono:'
                'Le principali <strong>Funzioni aziendali di supporto</strong> sono:'
            },
            {
              strong: (chunks) => <strong>{chunks}</strong>
            }
          )}
        </div>

        <ul className="mt-2">
          <li>
            {intl.formatMessage(
              {
                defaultMessage: '<strong>FINANZA, AMMINISTRAZIONE E CONTROLLO</strong>'
              },
              {
                strong: (chunks) => <strong>{chunks}</strong>
              }
            )}
          </li>
          <li>
            {intl.formatMessage(
              {
                defaultMessage: '<strong>RISORSE UMANE</strong>'
              },
              {
                strong: (chunks) => <strong>{chunks}</strong>
              }
            )}
          </li>
          <li>
            {intl.formatMessage(
              {
                defaultMessage:
                  // '<strong>SUPPORTO ALLE OPERAZIONI DI BUSINESS, QUALITÀ E SUPPORTO ORGANIZZATIVO</strong>'
                  '<strong>SALES OPERATIONS</strong>'
              },
              {
                strong: (chunks) => <strong>{chunks}</strong>
              }
            )}
          </li>
          <li>
            {intl.formatMessage(
              {
                defaultMessage: '<strong>CUSTOMER FULFILLMENT</strong>'
              },
              {
                strong: (chunks) => <strong>{chunks}</strong>
              }
            )}
          </li>
          <li>
            {intl.formatMessage(
              {
                defaultMessage: '<strong>ACQUISTI</strong>'
              },
              {
                strong: (chunks) => <strong>{chunks}</strong>
              }
            )}
          </li>
          <li>
            {intl.formatMessage(
              {
                defaultMessage: '<strong>MARKETING, COMUNICAZIONE E CSR</strong>'
              },
              {
                strong: (chunks) => <strong>{chunks}</strong>
              }
            )}
          </li>
          <li>
            {intl.formatMessage(
              {
                defaultMessage: '<strong>QUALITÀ</strong>'
              },
              {
                strong: (chunks) => <strong>{chunks}</strong>
              }
            )}
          </li>
          <li>
            {intl.formatMessage(
              {
                defaultMessage: '<strong>IT</strong>'
              },
              {
                strong: (chunks) => <strong>{chunks}</strong>
              }
            )}
          </li>
        </ul>
      </div>
    </div>
  );
};

ListOrganization.displayName = "L'Azienda Storia Mobile ";
export { ListOrganization };
